import React from 'react'
import PropTypes from 'prop-types'
import { Columns, Rows, Icon } from 'src/components'
import { getColor } from 'src/styles'
import styles from './Indicator.scss'

/**
 * Displays a title and a subtitle with an associated icon.
 */
const Indicator = ({ icon, separator, title, subtitle, color, height, size, ...domProps }) => {
  const fontStyle = { fontSize: height }
  const colorStyle = { color: getColor(color) }
  const bgColorStyle = { backgroundColor: getColor(color) }

  return (
    <Columns {...domProps} style={fontStyle} layout="auto" align="center">
      {!!icon && <Icon fixedWidth icon={icon} className={styles.icon} color={color} size={size} />}
      {separator && <div className={styles.separator} style={bgColorStyle} />}
      <Rows className={styles.text} gap="0" justify="center">
        {!!title && (
          <div className={styles.title} style={colorStyle} title={typeof title === 'string' ? title : undefined}>
            {title}
          </div>
        )}
        {!!subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      </Rows>
    </Columns>
  )
}

Indicator.defaultProps = {
  icon: '',
  separator: false,
  unit: '',
  subtitle: '',
  color: 'dark',
  height: '2rem',
  size: 'xl',
}

Indicator.propTypes = {
  /**
   * The associated icon.
   */
  icon: PropTypes.elementType,
  /**
   * Add a separator between icon and text.
   */
  separator: PropTypes.bool,
  /**
   * The title to be displayed.
   */
  title: PropTypes.node,
  /**
   * The description of the indicator.
   */
  subtitle: PropTypes.node,
  /**
   * The color of the icon (CSS value).
   */
  color: PropTypes.string,
  /**
   * The height of the indicator (CSS value).
   */
  height: PropTypes.string,
  /**
   * The size of the icon.
   */
  size: PropTypes.string,
}

export default Indicator
